import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Box,
  ButtonIcon,
  Chip,
  Icon,
  Tooltip,
  Typography,
} from '@saviynt/design-system';

import { CF_NEU_MED } from '../../../../shared/constants';

/**
 * ResponseActionBar
 */
function ResponseActionBar() {
  return (
    <Box tag='div' className='ResponseActionBar'>
      <Box tag='div' className='ResponseActionBar-footerControls'>
        <Box tag='div' className='ResponseActionBar-footerControlsActions'>
          <Tooltip
            trigger={
              <ButtonIcon
                size='small'
                kind='saviGhost'
                ariaLabel='Copy'
                icon={<Icon kind='Copy' size='xSmall' />}
                onClick={() => {}}
              />
            }
            text='Copy'
            placement='bottom'
          />
          <Tooltip
            trigger={
              <ButtonIcon
                size='small'
                kind='saviGhost'
                ariaLabel='Export'
                icon={<Icon kind='Export' size='xSmall' />}
                onClick={() => {}}
              />
            }
            text='Export'
            placement='bottom'
          />
          <Tooltip
            trigger={
              <ButtonIcon
                size='small'
                kind='saviGhost'
                ariaLabel='Thumbs Up'
                icon={<Icon kind='ThumbsUp' size='xSmall' />}
                onClick={() => {}}
              />
            }
            text='Good Response'
            placement='bottom'
          />
          <Tooltip
            trigger={
              <ButtonIcon
                size='small'
                kind='saviGhost'
                ariaLabel='Thumbs Down'
                icon={<Icon kind='ThumbsDown' size='xSmall' />}
                onClick={() => {}}
              />
            }
            text='Bad Response'
            placement='bottom'
          />
        </Box>
        <Chip
          size='xxSmall'
          label='Show Reasoning'
          rightIcon={<Icon kind='ChevronDownSmall' />}
        />
      </Box>
      <Box tag='div' className='ResponseActionBar-footerStats'>
        <Typography kind='body3' color={CF_NEU_MED}>
          <FormattedMessage
            id='NMmzcX'
            defaultMessage='WIP: {content}'
            description='WIP text with placeholder for feature name in Savi AI Copilot sidebar'
            values={{ content: '2h ago' }}
          />
        </Typography>
      </Box>
    </Box>
  );
}

export default ResponseActionBar;
